const bannerTitle = {
  id: 'helpCenterPage.bannerTitle',
};
const bannerSubtitle = {
  id: 'helpCenterPage.subTitle',
};
const bannerDescription = {
  id: 'helpCenterPage.description',
};
const textIds = {
  bannerTitle,
  bannerSubtitle,
  bannerDescription,
};

export default textIds;
